/**
 * Authentication-related GraphQL queries
 */

export const GET_USER_PROFILE_QUERY = `
  query GetUserProfile($id: Int!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      phone_number
      address
      work_phone_number
      user_birthday
      work_start_date
      work_end_date
      annual_leave_balance
      user_annual_leave_balance
      total_leaves_used
      role
      title_id
      relative_first_name
      relative_last_name
      relative_phone_number
      relative_degree
      company_id
      team_id
      company {
        id
        name
      }
      team {
        id
        name
        group_id
        group {
          id
          name
        }
      }
      created_at
      updated_at
    }
  }
`;

export const GET_USER_WITH_TEAM_QUERY = `
  query GetUserWithTeam($id: Int!) {
    users_by_pk(id: $id) {
      id
      email
      first_name
      last_name
      role
      company_id
      team_id
      title_id
      user_birthday
      is_expense_manager
      is_loan_request_manager
      manages_collections
      can_view_communication_report
      company {
        id
        name
      }
      title {
        id
        title_name
        title_code
      }
      team {
        id
        name
        group_id
        group {
          id
          name
        }
      }
    }
  }
`;
